// config
import * as http from 'utils/http';
import config from 'config';

const updateTicketDetail = async ({ id, updateTicketDetailDto }) => {
  return http.patch(`${config.API_URL}price-negotiation/tickets/${id}/`, updateTicketDetailDto);
};

export default updateTicketDetail;
